import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toJS} from "../hocs/toJs";

const parseRoles = (roles) => {
  const parsedNews = [];
  roles.valueSeq().toArray().forEach(role => (
    parsedNews.push({
      id: role.get('id'),
      name: role.get('name'),
    })));
  return parsedNews;
};

//Higher order component for user authorization handling
const AuthorizationHOC = (allowedRoles) =>
  (WrappedComponent) => {
    class WithAuthorization extends Component {
      constructor(props) {
        super(props)

      }
      render() {
        //check if the logged in user role matches the allowed roles for the context inside the wrapped
        //component, then the wrapped component will be rendered, else a not allowed message appears
        let isAuth = false;
        try {
          isAuth = allowedRoles.includes(this.props.personRoles[0].name)
        } catch (e) {
          isAuth = false
        }
        if (isAuth) {
          return <WrappedComponent {...this.props} />
        } else {
          return <h1>No page for you!</h1>
        }
      }
    }

    const mapStateToProps = (state) => {
      return {
        personRoles: state.loggedInPerson.get('roles')
      }
    };

    const mapDispatchToProps = (dispatch) => {
      return {
      }
    };

    return connect(mapStateToProps, mapDispatchToProps)(toJS(WithAuthorization));
  };


export default AuthorizationHOC;



// WEBPACK FOOTER //
// ./src/components/auth/authorizationHOC.js